export default __webpack_public_path__ + "static/banner_background_max-1da4f86398c68c051e445f01a5c4afd5.png";